import { Dispatch, SetStateAction, useCallback, useEffect } from "react";

const useAdvertising = () => {
  useEffect(() => {
    const nav = document.querySelector("nav");
    const advertisingSectionContent = document.querySelector(
      ".advertising-section-content"
    ) as HTMLElement;

    if (nav) {
      advertisingSectionContent.style.marginTop = `-${nav.clientHeight}px`;
    }
  }, []);

  const handleScrollToForm = useCallback(
    (setIsHeroBunnerScrolledToTop: Dispatch<SetStateAction<boolean>>) => {
      // Set a flag to indicate programmatic scrolling
      window.sessionStorage.setItem("isProgrammaticScroll", "true");

      // Set the flag to prevent HeroBunnerSection from intercepting the scroll
      setIsHeroBunnerScrolledToTop(true);

      const formElement = document.getElementById("ad-contact-form-container");
      if (!formElement) return;

      const duration = 0; // 0 second
      const start = window.scrollY;
      const end = formElement.getBoundingClientRect().top + window.scrollY;
      const startTime = performance.now();

      const easeOutCubic = (t: number) => {
        return 1 - Math.pow(1 - t, 3);
      };

      const animate = (currentTime: number) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        window.scrollTo(0, start + (end - start) * easeOutCubic(progress));

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          // Clear the flag after animation completes
          setTimeout(() => {
            window.sessionStorage.removeItem("isProgrammaticScroll");
          }, 0);
        }
      };

      requestAnimationFrame(animate);
    },
    []
  );

  return { handleScrollToForm };
};

export default useAdvertising;
